import { useMutation } from '@apollo/react-hooks';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { AccountContext } from '../../../../components/AccountContext';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { DELETE_SUPER__PROFILE } from '../services/super--profiles.service';

const messages = defineMessages({
  header: {
    id: 'account.super-profiles.delete-confirmation-modal.header',
    defaultMessage: 'Confirm deleting SuperProfile',
  },
  firstParagraph: {
    id: 'account.super-profiles.delete-confirmation-modal.first-paragraph',
    defaultMessage: 'Please make sure that you actually want to delete this SuperProfile.',
  },
  secondParagraph: {
    id: 'account.super-profiles.delete-confirmation-modal.second-paragraph',
    defaultMessage: 'If you do, all SuperMatches based on it will also be deleted.',
  },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  submit: { id: 'actions.submit', defaultMessage: 'Submit' },
});

const DeleteSuperProfileConfirmationDialog = ({ superProfileId, hide }) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { formatMessage } = useIntl();

  const [deleteSuperProfileMutation, { loading }] = useMutation(DELETE_SUPER__PROFILE, {
    refetchQueries: ['superProfilesQuery'],
  });

  const deleteSuperProfile = async () => {
    try {
      await deleteSuperProfileMutation({
        variables: {
          input: {
            accountId: currentAccount,
            superProfileId,
          },
        },
      });

      hide();
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  const header = <div className="dashboard-panel-header">{formatMessage(messages.header)}</div>;

  return (
    <Dialog visible={!!superProfileId} onHide={hide} header={header} modal>
      <p>{formatMessage(messages.firstParagraph)}</p>
      <p>{formatMessage(messages.secondParagraph)}</p>
      <div className="mt20 flex-center">
        <Button
          type="button"
          disabled={loading}
          className="p-button-secondary"
          label={formatMessage(messages.cancel)}
          onClick={hide}
        />
        <Button
          type="button"
          disabled={loading}
          className="p-button-primary"
          label={formatMessage(messages.submit)}
          onClick={deleteSuperProfile}
        />
      </div>
    </Dialog>
  );
};

export default DeleteSuperProfileConfirmationDialog;
